// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import styled from 'styled-components';
import { redirectTo } from '../../utils/url';
import * as selectors from "../../modules/selectors";
import * as actions from '../../modules/actions';
import {
	PageTitle,
	ButtonPrimaryLink,
	ButtonLoadMore,
	TextModal,
	AdsContainer,
	Ad,
	OneColumnLayout,
	AlertScreen,
	Preloader
} from '../../components';
import ArrowDown from '../../components/Icons/ArrowDown';
import SearchForm from '../../components/SearchForm';
import JoinLeagueLayout from './leaguesJoin/JoinLeagueLayout';
import JoinLeagueList from './leaguesJoin/JoinLeagueList';
import JoinLeaguePopup from './leaguesJoin/JoinLeaguePopup';
import JoinLeagueSettingsPopup from './leaguesJoin/JoinLeagueSettingsPopup';

type Props = {
	showToJoinDraftLeagues: Function,
	showToJoinLoadMoreDraftLeagues: Function,
	joinToDraftLeague: typeof actions.leagueDraft.joinToDraftLeague,
	leagues_to_join: Array<Object>,
	is_load_more: boolean,
	join_to: Object,
	offset: number,
	clearJoinToDraftLeagueErrors: typeof actions.leagueDraft.clearJoinToDraftLeagueErrors,
	actual_round: Object,
	match: {
		params: Object,
	}
}

type State = {
	search_value: string,
	is_show_join_popup: boolean,
	is_show_settings_popup: boolean,
	league_to_join: Object
}

const ButtonPrimaryLinkStyled = styled(ButtonPrimaryLink)`
	max-width: 200px;
	margin-left: 20px;
	width: 100%;
`;

class LeaguesJoinPage extends React.Component<Props, State> {
	state = {
		search_value: '',
		is_show_join_popup: false,
		is_show_settings_popup: false,
		league_to_join: {}
	};

	componentDidMount() {
		this.props.showToJoinDraftLeagues({ offset: 0, q: this.state.search_value });

		const {
			match: {
				params
			}
		} = this.props;

		if(params && params.code) {
			this.props.joinToDraftLeague({ code: params.code });
		}
	}

	join = id => {
		this.props.joinToDraftLeague({ league_id: id });
	};

	handleErrorModalClose(){
		const { clearJoinToDraftLeagueErrors } = this.props;
		clearJoinToDraftLeagueErrors();
	};

	get error_modal() {
		const { join_to } = this.props;

		return (
			<TextModal
				onClick={this.handleErrorModalClose.bind(this)}
				header_text='Error'
				text={ join_to.error } />
		);
	}

	handleSearchSubmit(api_params) {
		this.setState({
			search_value: api_params.q
		});
		this.props.showToJoinDraftLeagues(api_params);
	};

	handleLeagueJoinPopup({ id }: Object) {
		const { leagues_to_join } = this.props,
			league_to_join = _.find(leagues_to_join, { id });

		this.setState({
			is_show_join_popup: true,
			league_to_join
		});
	}

	handleLeagueSettingsPopup({ id }: Object) {
		const { leagues_to_join } = this.props,
			league_to_join = _.find(leagues_to_join, { id });

		this.setState({
			is_show_settings_popup: true,
			league_to_join
		});
	}

	handleLeagueJoinPopupHide() {
		this.setState({
			is_show_join_popup: false,
			league_to_join: {}
		});
	}

	handleLeagueSettingsPopupHide() {
		this.setState({
			is_show_settings_popup: false,
			league_to_join: {}
		});
	}

	loadMore() {
		const { offset } = this.props;
		this.props.showToJoinLoadMoreDraftLeagues({
			offset: offset + 10,
			q: this.state.search_value
		});
	}

	componentDidUpdate(prev_props) {
		const is_prev_league_id_null = prev_props.join_to.league_id === null,
			is_league_id_null = this.props.join_to.league_id === null,
			is_not_equal = prev_props.join_to.league_id !== this.props.join_to.league_id;

		if (is_prev_league_id_null && !is_league_id_null && is_not_equal) {
			redirectTo(`/draft/league/${this.props.join_to.league_id}`);
		}
	}

	get check_is_locked_game() {
		const { actual_round: { id, status } } = this.props;

		if (id === 25 && status === 'complete') {
			return (
				<OneColumnLayout>
					<AlertScreen
						text={'Leagues cannot be joined/created after Round 25 has begun.'}
					/>
				</OneColumnLayout>
			);
		}

		return null;
	}

	render() {
		const { actual_round: { id, status } } = this.props;

		if (!id) {
			return <Preloader />;
		}

		if (id === 25 && status === 'complete') {
			return this.check_is_locked_game;
		}

		return this.render_main;
	}

	get render_main() {
		const { leagues_to_join, is_load_more, join_to } = this.props;
		const { is_show_join_popup, league_to_join, is_show_settings_popup } = this.state;
		return (
			<React.Fragment>
				<AdsContainer>
					<Ad
						adUnit='join-a-league'
						size='top'
					/>
				</AdsContainer>
				<JoinLeagueLayout>
					{join_to.error ? this.error_modal : null}
					<PageTitle>
						Join a League
					</PageTitle>

					<div className="search-form-wrapper">
						<SearchForm
							placeholder="Search for a Public League or enter your Private PIN"
							field_name="q"
							onSubmit={this.handleSearchSubmit.bind(this)}
						/>
						<ButtonPrimaryLinkStyled to="/leagues/create">
							OR, CREATE LEAGUE
						</ButtonPrimaryLinkStyled>
					</div>

					<JoinLeagueList
						handleLeagueJoinPopup={this.handleLeagueJoinPopup.bind(this)}
						handleLeagueSettingsPopup={this.handleLeagueSettingsPopup.bind(this)}
						leagues_list={leagues_to_join}
						join={this.join}
					/>

					{is_show_join_popup ? (
						<JoinLeaguePopup
							onClick={this.handleLeagueJoinPopupHide.bind(this)}
							join={this.join}
							league={league_to_join}
						/>
					) : null}

					{is_show_settings_popup ? (
						<JoinLeagueSettingsPopup
							join={this.join}
							onClick={this.handleLeagueSettingsPopupHide.bind(this)}
							league={league_to_join}
						/>
					) : null}

					{is_load_more ? (
						<ButtonLoadMore onClick={this.loadMore.bind(this)}>
							Load More <ArrowDown />
						</ButtonLoadMore>
					) : null}

				</JoinLeagueLayout>
				<AdsContainer>
					<Ad
						adUnit='join-a-league'
						size='bottom'
					/>
				</AdsContainer>
			</React.Fragment>
		);
	}
}

const mapStateToProps = state => ({
	leagues_to_join: state.leagues.show_to_join.ordered_ids.map(
		league_id => state.leagues.by_id[league_id]
	),
	is_load_more: state.leagues.show_to_join.ordered_ids.length % 10 === 0,
	join_to: state.leagues.join_to,
	offset: state.leagues.show_to_join.offset,
	actual_round: selectors.rounds.getActualRound(state),
});

const mapDispatchToProps = {
	showToJoinDraftLeagues: actions.leagueDraft.showToJoinDraftLeagues,
	showToJoinLoadMoreDraftLeagues: actions.leagueDraft.showToJoinLoadMoreDraftLeagues,
	joinToDraftLeague: actions.leagueDraft.joinToDraftLeague,
	joinToDraftLeagueSuccess: actions.leagueDraft.joinToDraftLeagueSuccess,
	clearJoinToDraftLeagueErrors: actions.leagueDraft.clearJoinToDraftLeagueErrors,
};

export const LeaguesJoin = connect(
	mapStateToProps,
	mapDispatchToProps
)(LeaguesJoinPage);

export default LeaguesJoin;


// WEBPACK FOOTER //
// ./src/pages/leagues/LeaguesJoin.js